var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeafIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63347 10.0216C11.5987 6.13149 15.3789 2.06196 13.7899 0.542701C12.1798 -1.07605 6.36659 1.14728 2.88409 4.29539C-0.74384 7.29871 1.57917 10.6412 2.24776 11.3095C3.00783 12.0503 5.84127 13.98 8.63347 10.0216Z",
    stroke: "#4CAF50",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4965 2.875C6.73305 5.81281 3.42204 9.38734 0.832031 13.3335",
    stroke: "#4CAF50",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12891 3.48438C7.29946 4.08437 7.47219 4.68833 7.64895 5.29873C8.28374 5.48516 8.91822 5.66975 9.55549 5.85525",
    stroke: "#4CAF50",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70703 5.01758C5.08753 5.68614 5.47361 6.36205 5.86683 7.04652C6.54875 7.43162 7.22541 7.81029 7.89896 8.18375",
    stroke: "#4CAF50",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07031 7.32812C3.36584 7.9174 3.66975 8.51586 3.98389 9.12442C4.56627 9.41707 5.14089 9.70084 5.70932 9.97757",
    stroke: "#4CAF50",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafIcon);
export default __webpack_public_path__ + "static/media/leaf-icon.b2a837473a9c31343b73781ddee97008.svg";
export { ForwardRef as ReactComponent };